import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LABELGENAPI } from '../../../API';

// Our components
import TrackingDrawer from '../../../pages/General/TrackingDrawer'
import Carrier from '../../General/Carrier'
import OrderStatus from '../../General/OrderStatus'
import Customer from '../../../pages/General/Customer'
import CarrierTracking from '../../../pages/General/CarrierTracking'
import Filters from './Filters'
import Search from './Search'
import DynamicColumns from '../../../pages/General/DynamicColumns'
import Notification from '../../../pages/General/Notification'
import NorowsData from '../../../pages/General/NorowsData'
import Date from '../../../pages/General/Date'
import OrderDrawer from '../../../pages/General/OrderDrawer'
import ShipmentRate from '../../../pages/General/ShipmentRate'
import Printer from '../../../pages/General/Printer'
import PageSearch from '../../../pages/General/PageSearch'

import { getCarrierDisplayName } from '../../../pages/General/carrierMapper';
import { printBulkLabels } from '../../../pages/Orders-new/ordersSlice';
// mui components
import {
    Typography,
    FormControl,
    Pagination,
    IconButton,
    Tooltip,
    Popover,
    Stack,
    Select,
    MenuItem
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ViewColumnSharpIcon from '@mui/icons-material/ViewColumnSharp';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import InfoIcon from '@mui/icons-material/Info';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Badge from '@mui/material/Badge';
import CircularProgress from '@mui/material/CircularProgress';
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {
    doGetMysqlDeliveries,
    fetchDeliveriesColumns,
    saveDeliveriesColumns,
    fetchShipmentCategoryCountData,
    resetDeliveriessNotifications
} from './deliveriesmysqlSlice';
import { fetchCustomerDetails } from './trackingEventsSlice';
import {
    fetchOrderDetail
} from '../../../pages/OrderDetail/orderdetailsSlice';
// Shared enterprise style object for the uniform action utilities matrix
const utilityIconButtonStyles = (isActive) => ({
    color: '#1976d2', // --- FIXED CORPORATE ACCENT BLUE MATRIX BRAND TOKEN ---
    padding: '10px',
    borderRadius: '10px',
    backgroundColor: isActive ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
    border: isActive ? '1px solid rgba(25, 118, 210, 0.2)' : '1px solid #E2E8F0',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        backgroundColor: isActive ? 'rgba(25, 118, 210, 0.12)' : 'rgba(241, 245, 249, 0.8)',
        borderColor: isActive ? 'rgba(25, 118, 210, 0.3)' : '#CBD5E1',
        transform: 'translateY(-1px)'
    },
    '&:active': {
        transform: 'translateY(0)'
    }
});
const DeliveriesMysqlPage = () => {
    const dispatch = useDispatch();
    const deliveries = useSelector(state => state.deliveriesmysql);
    const profile = useSelector(state => state.auth);
    const orders = useSelector(state => state.ordersNew);
    const [meta, setMeta] = useState(deliveries.deliveriesData.meta);
    const [showFilter, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(true);
    const [showDynamicColumn, setShowDynamicColumn] = useState(false);
    const [columnCheckedObject, setColumnCheckedObject] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [trackingDrawerVisible, setTrackingDrawerVisible] = useState(false);
    const [orderDrawerVisible, setOrderDrawerVisible] = useState(false);
    const [trackingMessage, setTrackingMessage] = useState(null);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [isMultiPiece, setIsMultiPiece] = useState(false)
    const [value, setValue] = React.useState(0);
    const [breakdownAnchorEl, setBreakdownAnchorEl] = useState(null);
    const [selectedBreakdown, setSelectedBreakdown] = useState(null);
    const [isLoadingDuties, setIsLoadingDuties] = useState(false);
    const [pageNumber, setPageNumber] = useState("")
    const [checkedIds, setCheckedIds] = useState([]);
    const [checkedRows, setCheckedItems] = useState([]);
    const [isPrintingLoading, setIsPrintingLoading] = useState(false);
    const printSelectedBulkLabels = () => {
        let labelUrls = [];
        
        // Extract label URLs from checked rows prioritizing valid endpoints
        checkedRows.forEach((row) => {
            if (row && (!row.is_voided || row.is_voided === false)) {
                const url = row.detachable_label_url || 
                            row.detachable_direct_label_url || 
                            row.label_url || 
                            row.direct_label_url;

                if (url && url !== "" && !labelUrls.includes(url)) {
                    labelUrls.push(url);
                }
            }
        });
        if (labelUrls.length === 1) {
            setPrintUrl(labelUrls[0]);
            setIsPrinted(false);
        } else if (labelUrls.length > 1) {
            const userId = profile?.profile?.id || profile?.id;
            dispatch(printBulkLabels(labelUrls, userId));
        }
    };
    const orderCallback = (item) => {
        dispatch(fetchOrderDetail(item));
        setOrderDrawerVisible(true)
    }
    const orderOnClose = (values) => {
        setOrderDrawerVisible(false);
    };

       
    const handleDutiesClick = async (event, rowData) => {
        setBreakdownAnchorEl(event.currentTarget);
        setIsLoadingDuties(true);
        setSelectedBreakdown(null);
        try {
            const trackingNumber = rowData?.tracking_number;
            const userId = rowData?.userid;

            if (!trackingNumber) {
                setSelectedBreakdown({ error: "No tracking number found for this order." });
                return;
            }

            const response = await LABELGENAPI.get(`/orders/get-duties-info`, {
                params: { 
                    tracking_number: trackingNumber, 
                    userid: userId 
                }
            });

            const resData = response.data || {};
            const isUSDProfile = profile?.profile?.currency_code === "USD";

            // Extract rate container safely
            const rateObj = resData.shipment_rates || resData.rate || {};

            // 1. Try USD path if user is set to USD
            let targetBreakdown = null;
            let currencyUsed = "CAD";

            if (isUSDProfile) {
                targetBreakdown = rateObj.usd_breakdown?.duty_breakdown 
                    || rateObj.usd_duty_breakdown 
                    || rateObj.usd_breakdown;

                if (targetBreakdown && Object.keys(targetBreakdown).length > 0) {
                    currencyUsed = "USD";
                }
            }

            // 2. Fallback to standard/CAD response if USD breakdown was empty or profile is CAD
            if (!targetBreakdown || Object.keys(targetBreakdown).length === 0) {
                targetBreakdown = rateObj.breakdown?.duty_breakdown 
                    || rateObj.duty_breakdown 
                    || rateObj.breakdown;
                currencyUsed = "CAD";
            }

            if (targetBreakdown && Object.keys(targetBreakdown).length > 0) {
                setSelectedBreakdown({
                    data: targetBreakdown,
                    currency: currencyUsed
                });
            } else {
                setSelectedBreakdown({ message: "No active duty breakdowns found." });
            }

        } catch (error) {
            console.error("Failed fetching duty breakdown:", error);
            setSelectedBreakdown({ error: "Failed to load breakdown details." });
        } finally {
            setIsLoadingDuties(false);
        }
    };
    const renderDutyTooltip = (breakdownPayload) => {
        if (!breakdownPayload || typeof breakdownPayload !== 'object') return null;

        // Handle payload wrapper structure
        const dutyData = breakdownPayload.data || breakdownPayload;
        const currencyTag = (breakdownPayload.currency || (profile?.profile?.currency_code === "USD" ? "USD" : "CAD"));

        const elements = [];
        const actualBreakdown = Array.isArray(dutyData) ? dutyData[0] : dutyData;

        if (!actualBreakdown || typeof actualBreakdown !== 'object') return null;

        Object.entries(actualBreakdown).forEach(([key, val]) => {
            // Skip metadata keys or empty values
            if (val === undefined || val === null || val === "" || key === "packages" || key === "details" || key === "currency_code") return;

            // Clean up internal database suffix tags (e.g. "DUTY_1" -> "Duty 1")
            const cleanKey = key.replace(/_\d+$/, ''); 
            
            let formattedKey = cleanKey
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1))
                .join(' ');

            if (formattedKey === "Zonos Markup") {
                formattedKey = "SC Fee";
            }

            let numVal = null;

            if (typeof val === 'object' && !Array.isArray(val)) {
                numVal = val.value !== undefined ? val.value : (val.amount !== undefined ? val.amount : val.price);
            } else if (typeof val === 'number' || !isNaN(val)) {
                numVal = val;
            }

            if (numVal !== null && numVal !== undefined && numVal !== "") {
                elements.push({
                    label: formattedKey,
                    value: parseFloat(numVal).toFixed(2),
                    currency: currencyTag
                });
            }
        });

        if (elements.length === 0) return null;

        return (
            <Box sx={{ p: 0.5 }}>
                {elements.map((item, idx) => (
                    <Box 
                        key={idx} 
                        sx={{ 
                            fontSize: '11px', 
                            color: '#ffffff', 
                            display: 'flex', 
                            alignItems: 'baseline', 
                            gap: '4px',
                            whiteSpace: 'nowrap', 
                            mb: 0.5 
                        }}
                    >
                        <span>{item.label}: {item.value}</span>
                        <Box component="span" sx={{ fontSize: '10px', color: '#919eab' }}>
                            {item.currency}
                        </Box>
                    </Box>
                ))}
            </Box>
        );
    };

    const handleDutiesClose = () => {
        setBreakdownAnchorEl(null);
        setSelectedBreakdown(null);
    };

    let defaultColumns = [{
        field: 'order_id',
        headerName: 'Order',
        headerClassName: 'super-app-theme--header',
        minWidth: 180,
        sortable: true,
        flex: 1,
        renderCell: (params) => {
            return <span style={{ color: 'rgb(24, 144, 255)', cursor: 'pointer' }} onClick={e => { orderCallback(params.row.order_id) }}>{params.row.order_id}</span>

        }
    },
    {
        field: 'tracking_number',
        headerName: 'Tracking Number',
        minWidth: 250,
        sortable: false,
        flex: 1,
        renderCell: (params) => {
            let tracking_number = (params.row.tracking_number
                && typeof params.row.tracking_number !== "undefined" && params.row.tracking_number !== null)
                ? params.row.tracking_number : "";
            let carrier_name = (params.row.label_carrier_name 
                && typeof params.row.label_carrier_name !== "undefined" 
                && params.row.label_carrier_name !== null)
                ? getCarrierDisplayName(params.row.label_carrier_name, tracking_number)
                : "";
            let message = (params.row && params.row.is_manifest_closed === false)
                ? "This shipment manifest is not yet closed" : null;
            let tracking = { "tracking_number": tracking_number, "carrier_name": carrier_name }
            return (
                <CarrierTracking trackingItems={tracking} dispatchCallback={trackingCallback} carrierImageWidth="60px" message={message} />
            )
        }
    },
    {
        field: 'shipment_status',
        headerName: 'Shipment Status',
        minWidth: 180,
        sortable: false,
        flex: 1,
        renderCell: (params) => {
            return (
                <OrderStatus orderStatus={params.row.shipment_status}
                />
            )
        }
    },
    {
        field: 'customer_first_name',
        headerName: 'Customer',
        minWidth: 170,
        sortable: false,
        flex: 1,
        renderCell: (params) => {
            let name = ""
            if (params.row.customer_first_name !== "undefined" && params.row.customer_first_name !== null) {
                name = params.row.customer_first_name;
            }
            if (params.row.customer_last_name !== "undefined" && params.row.customer_last_name !== null && params.row.customer_last_name !== params.row.customer_first_name) {
                name = name + " " + params.row.customer_last_name
            }
            return (
                <Customer name={name} />
            )
        }
    },
    {
        field: 'shipment_date',
        headerName: 'Shipment Date',
        minWidth: 180,
        flex: 1,
        renderCell: (params) => {
            if (params.row && params.row.shipment_date) {
                return <Date date={params.row.shipment_date} />
            } else {
                return "-"
            }
        }
    },
    {
        field: 'delivered_at',
        headerName: 'Delivery Date',
        minWidth: 180,
        flex: 1,
        renderCell: (params) => {
            if (params.row && params.row.delivered_at) {
                return <Date date={params.row.delivered_at} />
            } else {
                return "-"
            }
        }
    },
    {
        field: 'rate_total_charges',
        headerName: 'Shipment Rate',
        sortable: false,
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const row = params.row || {};
            const voided = Boolean(row.is_void_in_progress || row.is_voided);

            // Resolve user profile currency fallback
            const storeCurrency = profile?.profile?.currency_code || "CAD";

            // Billed Currency Logic
            const billedCurrencyCode = row.rate_billed_currency_code ? row.rate_billed_currency_code : storeCurrency;

            // API Rate and Currency Logic based on USD preference
            const isProfileUSD = profile?.profile?.currency_code === "USD";
            const hasUsdRate = row.usd_rate_api_sub_total !== null && row.usd_rate_api_sub_total !== undefined;

            const apiRate = (isProfileUSD && hasUsdRate) ? row.usd_rate_api_sub_total : row.rate_api_sub_total;
            const apiCurrencyCode = (isProfileUSD && hasUsdRate) ? "USD" : "CAD";

            return (
                <ShipmentRate
                    billed_rate={row.rate_billed_total}
                    billed_currency_code={billedCurrencyCode}
                    api_rate={apiRate}
                    api_currency_code={apiCurrencyCode}
                    is_multi_piece={row.is_multi_piece_label}
                    is_voided={voided}
                />
            );
        }
    },
    {
        field: 'rate_api_duty_charge',
        headerName: 'Duties',
        sortable: false,
        flex: 1,
        minWidth: 100,
        renderCell: (params) => {
            const row = params?.row || {};
            
            // Check if shipment is voided or voiding in progress
            const isVoided = Boolean(row.is_void_in_progress || row.is_voided);

            // If voided, return hyphen immediately
            if (isVoided) {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                        <Typography variant="body2">-</Typography>
                    </Box>
                );
            }

            // 1. Check if user store currency is set to USD
            const storeCurrency = profile?.profile?.currency_code || profile?.currency_code || "CAD";
            const isUSD = storeCurrency === "USD";

            // 2. Select duty value & determine currency code text
            let dutyValue = null;
            let currencyLabel = "CAD";

            if (isUSD && row.usd_rate_api_duty_charge !== undefined && row.usd_rate_api_duty_charge !== null) {
                dutyValue = row.usd_rate_api_duty_charge;
                currencyLabel = "USD";
            } else {
                dutyValue = row.rate_api_duty_charge;
                currencyLabel = "CAD";
            }

            // 3. Render duty value matching ShipmentRate styling
            if (dutyValue !== null && dutyValue !== undefined && Number(dutyValue) > 0) {
                return (
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            width: '100%', 
                            height: '100%',
                            gap: 0.5 
                        }}
                    >
                        <Typography 
                            variant="body2" 
                            component="span" 
                            sx={{ 
                                display: 'inline-flex', 
                                alignItems: 'baseline', 
                                gap: '4px',
                                color: '#334155',
                                fontSize: '13.5px !important'
                            }}
                        >
                            <span>{parseFloat(dutyValue).toFixed(2)}</span>
                            <Box 
                                component="span" 
                                sx={{ 
                                    fontSize: '11px', 
                                    color: '#64748B', 
                                    fontWeight: 500
                                }}
                            >
                                {currencyLabel}
                            </Box>
                        </Typography>
                        
                        <IconButton 
                            size="small" 
                            onClick={(e) => handleDutiesClick(e, row)}
                            sx={{ 
                                color: '#919eab', 
                                p: 0.2
                            }}
                        >
                            <InfoIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                    </Box>
                );
            }

            // Fallback for zero or missing values
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                    <Typography variant="body2">-</Typography>
                </Box>
            );
        }
    },
    {
        field: 'fulfilment_by',
        headerName: 'Fulfilled By',
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: (params) => {
            const rowUserid = params.row?.userid;
            const storeDetails = profile?.profile?.all_users_store_details;
            let email = "-";

            if (storeDetails && rowUserid) {
                // First check if storeDetails is an object keyed by ID
                if (storeDetails[rowUserid] && storeDetails[rowUserid].email) {
                    email = storeDetails[rowUserid].email;
                } else if (Array.isArray(storeDetails)) {
                    // Fallback if storeDetails is a indexed array
                    const matchedUser = storeDetails.find(item => item && item.id == rowUserid);
                    if (matchedUser && matchedUser.email) {
                        email = matchedUser.email;
                    }
                } else {
                    // Fallback if storeDetails is an object array dictionary
                    const matchedUser = Object.values(storeDetails).find(item => item && item.id == rowUserid);
                    if (matchedUser && matchedUser.email) {
                        email = matchedUser.email;
                    }
                }
            }

            return (
                <Typography variant="body2" component="span">
                    {email}
                </Typography>
            );
        }
    },
    {
        field: 'action',
        headerName: 'Shipment Action',
        minWidth: 200,
        sortable: false,
        flex: 1,
        renderCell: (params) => {
            const trackingNumber = params.row.tracking_number ? params.row.tracking_number : "";
            let voided = ((params.row.is_void_in_progress && params.row.is_void_in_progress !== null) || (params.row.is_voided && params.row.is_voided !== null)) ? true : false
            if (trackingNumber != "" && voided != true && ((params.row.detachable_label_url) || (params.row.detachable_direct_label_url) || (params.row.label_url && params.row.label_url != "") || (params.row.direct_label_url && params.row.direct_label_url != ""))) {

                let url = "";
                if (params.row.detachable_label_url && params.row.detachable_label_url != "") {
                    url = params.row.detachable_label_url
                } else if (params.row.detachable_direct_label_url && params.row.detachable_direct_label_url != "") {
                    url = params.row.detachable_direct_label_url
                } else if (params.row.label_url && params.row.label_url != "") {
                    url = params.row.label_url
                } else if (params.row.direct_label_url && params.row.direct_label_url != "") {
                    url = params.row.direct_label_url
                }

                return <div>
                    <span style={{ marginRight: '10px' }}><Tooltip title="View" placement="left-start">
                        <IconButton onClick={() => window.open(url, '_blank')}>
                            <RemoveRedEyeIcon style={{ color: "#1890ff", cursor: 'pointer' }}  />
                        </IconButton>
                    </Tooltip>
                    </span>
                    <span style={{ marginRight: '10px' }}><Tooltip title="Print" placement="left-start">
                        <IconButton  onClick={() => { setPrintUrl(url); setIsPrinted(false) }} >
                            <LocalPrintshopIcon style={{ color: "#1890ff", cursor: 'pointer' }}
                               />
                        </IconButton>
                    </Tooltip>
                    </span>
                </div>
            } else {
                return <>-</>
            }
        }
    }]
    const [columns, setColumns] = useState(defaultColumns);

    const tabOnClick = (e,value) => {
        setValue(value);
        let shipment_status=""
        if(value==0){
            shipment_status=""
        }else if(value==1){
            shipment_status="Label Generated"
        }else if(value==2){
            shipment_status="Manifest Closed"
        }else if(value==3){
            shipment_status="Picked Up"
        }else if(value==4){
            shipment_status="In Transit"
        }else if(value==5){
            shipment_status="Issues"
        }else if(value==6){
            shipment_status="Delivered"
        }else if(value==7){
            shipment_status="Untracked"
        }else if(value==8){
            shipment_status="Voided"
        }
        setMeta({
            ...meta,
            ...{
                shipment_status_category: [shipment_status],
            }
        });
      };
   


    useEffect(() => {
        dispatch(fetchDeliveriesColumns());
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: 10,
                start_date: "",
                end_date: "",
                order_id: "",
                order_status: [],
                receiver_province: "",
                receiver_country_code: "",
                tracking_number: "",
                carrier_name: [],
                platform_tags: [],
                customer_name: "",
                shipment_status_category: [],
                shippingchimp_manifest_number: "",
                unclosed_shipment: 'false',
                sorting: JSON.stringify([{
                    field: 'shipment_date',
                    sort: 'desc',
                }])
            }
        });
    }, [dispatch])

    useEffect(() => {
        dispatch(doGetMysqlDeliveries({ ...meta }));
        dispatch(fetchShipmentCategoryCountData({ ...meta }));
    }, [meta])

    // Automatically clear selection after bulk label printing completes
    useEffect(() => {
        const bulkLabel = orders?.bulkLabel;

        // Check for valid filename and that the label hasn't been handled yet
        if (bulkLabel?.filename && bulkLabel?.is_shown === false) {
            const fullUrl = `${process.env.REACT_APP_LABELINGCHIMP_LABEL_API_DOMAIN}/merge-pdf?filename=${bulkLabel.filename}`;
            
            setPrintUrl(fullUrl);
            setIsPrinted(false);
            
            // Clear Datagrid row selection and reset loading state
            setCheckedIds([]);
            setCheckedItems([]);
            setIsPrintingLoading(false);
        }
    }, [orders?.bulkLabel?.filename, orders?.bulkLabel?.is_shown, orders?.bulkLabel?.loading]);

    const trackingCallback = (carriername, trackingNumber, message = null) => {
        setTrackingMessage(message)
        let apikey = (profile && profile.profile && profile.profile.api_token) ? profile.profile.api_token : "";
        const data = {'tracking_number': trackingNumber }
        dispatch(fetchCustomerDetails(data, apikey))
        setTrackingDrawerVisible(true)
    }
    const onClose = (values) => {
        setTrackingDrawerVisible(false);
    };

    useEffect(() => {
        if (deliveries.deliveriesColumns.columns && typeof deliveries.deliveriesColumns.columns.user_columns !== "undefined") {
            if (deliveries.deliveriesColumns.columns.user_columns.length !== 0) {
                setMeta(prevState => ({
                    ...prevState,
                    [`columns`]: JSON.stringify(deliveries.deliveriesColumns.columns.user_columns)
                }));
                Object.entries(deliveries.deliveriesColumns.columns.user_columns).map(([key, value]) => (
                    defaultColumns.splice(defaultColumns.length - 1, 0, {
                        field: value,
                        minWidth: 150,
                        sortable: false,
                        flex: 1,
                        headerName: key,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            if(key === "Weight"){
                                return  <span>{parseFloat(params.row.actual_weight).toFixed(2)}</span>
                            }else{
                                return getValueFromObject("row." + value, params)
                            }
                        }
                    })
                ))
            }
            setColumns(defaultColumns)
        }

    }, [deliveries.deliveriesColumns && deliveries.deliveriesColumns.columns])

    useEffect(() => {
        if (deliveries.deliveriesData && deliveries.deliveriesData.meta) {
            if(deliveries.deliveriesData.meta.shipment_status_category=="Label Generated"){
                setValue(1);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Manifest Closed"){
                setValue(2);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Picked Up"){
                setValue(3);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="In Transit"){
                setValue(4);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Issues"){
                setValue(5);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Delivered"){
                setValue(6);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Untracked"){
                setValue(7);
            }else if(deliveries.deliveriesData.meta.shipment_status_category=="Voided"){
                setValue(8);
            }else{
                setValue(0);
            }
        }

    }, [deliveries.deliveriesData && deliveries.deliveriesData.meta])

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onChangePerPage = (event) => {
        setPageNumber('')
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setPageNumber('')
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }

    const onInputChangePagination = (page) => {
        setPageNumber(page)
        let pagenumber = ''
        if (page == '') {
            pagenumber = 1
        } else {
            pagenumber = page
        }
        setMeta({
            ...meta,
            ...{
                page: pagenumber
            }
        });
    }

    const onMenuClick = (type, show) => {
        setShowSearch((type === "search" && show === true) ? true : false)
        setShowFilter((type === "filter" && show === true) ? true : false)
    }

    const handleColumnsClick = (event) => {
        setAnchorEl(event.currentTarget);
        setShowDynamicColumn(!showDynamicColumn)
    };

    const updateDynamicColumns = (clear = false) => {
        let data = columnCheckedObject
        if (clear == true) {
            data = {}
            setColumnCheckedObject({})
        }
        dispatch(saveDeliveriesColumns(data))
    }

    const handleColumnsClose = () => {
        setAnchorEl(null);
        setShowDynamicColumn(!showDynamicColumn)
    };

    const onExportClick = () => {
        const qs = Object.keys(meta)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
            .join('&');
        let url = process.env.REACT_APP_API_DOMAIN + '/labelgen/shipment/export?' + qs;
        window.open(url)
    }

    function getValueFromObject(path, sourceObject) {
        let paths = path.split(".")
        try {
            paths.map((key) => (
                sourceObject = sourceObject[key]
            ))
            return sourceObject
        }
        catch (err) {
            return "-"
        }

    }

    // ==========================================
    // PART 1: SUB-COMPONENTS ARCHITECTURE (TOOLBAR & PAGINATION)
    // ==========================================

    function CustomTotalRows() {
        return (
            <Box 
                className="custom-total-rows" 
                sx={{ 
                    display: 'inline-flex', 
                    alignItems: 'center',
                    py: 0.6,
                    px: 1.5,
                    borderRadius: '8px',
                    backgroundColor: '#F1F5F9', 
                    border: '1px solid #E2E8F0'
                }}
            >
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontSize: '12.5px', 
                        fontWeight: 600, 
                        color: '#475569',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        letterSpacing: '0.1px'
                    }}
                >
                    Showing <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {deliveries && deliveries.deliveriesData && deliveries.deliveriesData.data && deliveries.deliveriesData.data.length}
                    </strong> of <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {(deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.total) ? deliveries.deliveriesData.meta.total : 0}
                    </strong>
                </Typography>
            </Box>
        );
    }

    function CustomPagesizeoptions() {
        return (
            <Box className="custom-page-size-options" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Stack direction="row" spacing={1.2} alignItems="center">
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        Show
                    </Typography>
                    
                    <FormControl 
                        size="small" 
                        variant="outlined" 
                        sx={{
                            minWidth: 75,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                transition: 'all 0.2s',
                                border: '1px solid #E2E8F0',
                                '& fieldset': { border: 'none' },
                                '&:hover': { borderColor: '#CBD5E1' },
                                '&.Mui-focused': {
                                    borderColor: '#1976d2',
                                    boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
                                }
                            },
                            '& .MuiSelect-select': {
                                padding: '6px 10px',
                                fontSize: '13px',
                                fontWeight: 600,
                                color: '#1E293B',
                                textAlign: 'center'
                            }
                        }}
                    >
                        <Select
                            value={meta && meta.per_page}
                            onChange={onChangePerPage}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                        border: '1px solid #E2E8F0',
                                        '& .MuiMenuItem-root': {
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            py: 0.8,
                                            color: '#334155',
                                            '&.Mui-selected': {
                                                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                color: '#1976d2',
                                                fontWeight: 700
                                            }
                                        }
                                    }
                                }
                            }}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={1000}>1000</MenuItem>
                        </Select>
                    </FormControl>

                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        entries
                    </Typography>
                </Stack>
            </Box>
        );
    }

    // Custom Toolbar layout built to resolve absolute rendering overlaps
    function CustomToolbar() {
        return (
            <Box 
                sx={{ 
                    p: 2, 
                    bgcolor: '#F8FAFC', 
                    borderBottom: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    width: '100%',
                    boxSizing: 'border-box',
                    gap: 2
                }}
            >
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </Box>
        );
    }

    function CustomPagination() {
        return (
            <Box
                sx={{
                    p: 1.5,
                    bgcolor: '#F8FAFC',
                    borderTop: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    width: '100%',
                    boxSizing: 'border-box',
                    '& .MuiPaginationItem-root': {
                        fontSize: '13px',
                        fontWeight: 600,
                        borderRadius: '8px',
                        '&.Mui-selected': {
                            backgroundColor: '#1976d2', // --- THEME COLOR ACCENT SYNC ---
                            color: '#FFFFFF',
                            '&:hover': {
                                backgroundColor: '#115293'
                            }
                        }
                    }
                }}
            >
                <Pagination
                    color="primary"
                    shape="circular"
                    page={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.current_page}
                    count={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.meta && deliveries.deliveriesData.meta.last_page}
                    onChange={onChangePagination}
                />
                <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <PageSearch 
                        pagenumber={pageNumber} 
                        lastPage={deliveries?.deliveriesData?.meta?.last_page || 1} 
                        getpagenumber={onInputChangePagination} 
                    />
                </Box>
            </Box>
        );
    }


    return (
        <>
            {(deliveries && deliveries.deliveriesData && deliveries.deliveriesData.notification && deliveries.deliveriesData.notification.show) &&
                <Notification
                    is_open={deliveries.deliveriesData.notification.show}
                    messageType={deliveries.deliveriesData.notification.messageType}
                    messages={deliveries.deliveriesData.notification.messageContent}
                    handleClose={() => dispatch(resetDeliveriessNotifications())}
                />}
                {(deliveries && deliveries.deliveriesColumns && deliveries.deliveriesColumns.notification && deliveries.deliveriesColumns.notification.show) &&
                <Notification
                    is_open={deliveries.deliveriesColumns.notification.show}
                    messageType={deliveries.deliveriesColumns.notification.messageType}
                    messages={deliveries.deliveriesColumns.notification.messageContent}
                    handleClose={() => dispatch(resetDeliveriessNotifications())}
                />}
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            <div className="scmaincard">
                <Box 
                    className="sccardhead"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        pb: 2.5,
                        pt: 1,
                        flexWrap: 'wrap',
                        gap: 2,
                        boxSizing: 'border-box'
                    }}
                >
                    {/* Modern Primary Dashboard Section Heading Typography Context */}
                    <Typography 
                        variant="h5" 
                        component="h1" 
                        sx={{ 
                            fontWeight: 800, 
                            color: '#0F172A',
                            letterSpacing: '-0.5px'
                        }}
                    >
                        Deliveries
                    </Typography>

                    {/* Clean Flex Actions Toolbar Area Component Box Layout Container */}
                    <Box 
                        className="features-list"
                        component="div"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.2,
                            p: 0,
                            m: 0
                        }}
                    >
                        {/* 1. Global Interactive Search Panel Toggle Trigger */}
                        <Tooltip title="Search" placement="top">
                            <IconButton 
                                sx={utilityIconButtonStyles(showSearch)} 
                                onClick={() => onMenuClick("search", !showSearch)}
                            >
                                <SearchIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>

                        {/* 2. Global Interactive Filter Panel Toggle Trigger */}
                        <Tooltip title="Filter" placement="top">
                            <IconButton 
                                sx={utilityIconButtonStyles(showFilter)} 
                                onClick={() => onMenuClick("filter", !showFilter)}
                            >
                                <FilterAltOutlinedIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>

                        {/* Print Selected Bulk Labels Action Button */}
                        <Tooltip 
                            title={checkedIds.length === 0 ? "Select at least one delivery to print labels" : "Print Labels"} 
                            placement="top"
                        >
                            <span>
                                <IconButton 
                                    disabled={checkedIds.length === 0}
                                    sx={utilityIconButtonStyles(false)} 
                                    onClick={printSelectedBulkLabels}
                                >
                                    <LocalPrintshopIcon sx={{ fontSize: '20px' }} />
                                </IconButton>
                            </span>
                        </Tooltip>

                        {/* 3. CSV / Excel Core Dataset Shipment Export Engine */}
                        <Tooltip title="Export Shipments" placement="top">
                            <IconButton 
                                sx={utilityIconButtonStyles(false)} 
                                onClick={() => onExportClick()}
                            >
                                <FileDownloadIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>

                        {/* 4. Column Visibility Modifiers Grid Pipeline Configurations Selector */}
                        <Tooltip title="Columns" placement="top">
                            <IconButton
                                id="dynamic-column-positioned-button"
                                aria-controls={showDynamicColumn ? "dynamic-column-positioned-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={showDynamicColumn ? 'true' : undefined}
                                sx={utilityIconButtonStyles(showDynamicColumn)}
                                onClick={handleColumnsClick}
                            >
                                <ViewColumnSharpIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>

                <div>
                    {anchorEl != null && <DynamicColumns
                        visible={showDynamicColumn}
                        anchorEl={anchorEl}
                        columns={deliveries && deliveries.deliveriesColumns && deliveries.deliveriesColumns.columns}
                        columnCheckedObject={columnCheckedObject}
                        setColumnCheckedObject={setColumnCheckedObject}
                        updateDynamicColumns={updateDynamicColumns}
                        handleColumnsClose={handleColumnsClose}
                        loading={deliveries && deliveries.deliveriesColumns && deliveries.deliveriesColumns.loading}
                    />}
                    <Search visible={showSearch} meta={meta} setMeta={setMeta} />
                    <Filters visible={showFilter} meta={meta} setMeta={setMeta} />
                </div>
                <Box>
                    <Box 
                        className="deliveries_tab"
                        sx={{ 
                            border: '1px solid #E2E8F0', 
                            borderBottom: 'none',
                            backgroundColor: '#FFFFFF',
                            borderTopLeftRadius: '16px',
                            borderTopRightRadius: '16px',
                            overflow: 'hidden',
                            // Keeps custom layout containers above the DataGrid canvas inline
                            position: 'relative',
                            zIndex: 1,
                            '& .MuiTabs-root': {
                                minHeight: '48px'
                            },
                            // Premium indicator bar lining profile
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#1976d2', // --- SNAPPED TO THEME COLOR AXIS ACCENT ---
                                height: '3px',
                                borderRadius: '3px'
                            }
                        }}
                    >
                        <Tabs 
                            value={value} 
                            onChange={tabOnClick} 
                            aria-label="basic tabs example"
                            variant="scrollable" // Guarantees fluid responsiveness onto tight mobile resolutions
                            scrollButtons="auto"
                            sx={{
                                px: 1,
                                '& .MuiTab-root': {
                                    textTransform: 'none',
                                    minHeight: '48px',
                                    py: 1,
                                    px: 2.5,
                                    fontSize: '13.5px',
                                    fontWeight: 600,
                                    color: '#64748B',
                                    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                    gap: 1.5,
                                    '&:hover': {
                                        color: '#1976d2',
                                        backgroundColor: 'rgba(25, 118, 210, 0.02)'
                                    },
                                    '&.Mui-selected': {
                                        color: '#1976d2',
                                        fontWeight: 700,
                                        '& .MuiSvgIcon-root': {
                                            color: '#1976d2'
                                        }
                                    }
                                },
                                // Modernize inner placement structure of the notification elements
                                '& .MuiBadge-root': {
                                    display: 'inline-flex',
                                    alignItems: 'center'
                                },
                                '& .MuiBadge-badge': {
                                    backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                    color: '#1976d2',
                                    fontWeight: 700,
                                    fontSize: '11px',
                                    height: '18px',
                                    minWidth: '18px',
                                    px: 0.6,
                                    boxShadow: 'none',
                                    // Fine positioning alignment offset properties
                                    position: 'relative',
                                    transform: 'none',
                                    top: 'auto',
                                    right: 'auto',
                                    ml: 1
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: '18px',
                                    color: '#94A3B8',
                                    transition: 'color 0.2s ease-in-out'
                                }
                            }}
                        >
                            <Tab 
                                label="All" 
                                icon={
                                    <Badge badgeContent={deliveries && deliveries.shipmentStatusCount && deliveries.shipmentStatusCount.data && deliveries.shipmentStatusCount.data.total} showZero={true} max={1000000000}>
                                        <LocalShippingOutlinedIcon />
                                    </Badge>
                                } 
                                iconPosition="end" 
                            />
                            <Tab 
                                label="Label Generated"  
                                icon={
                                    <Badge badgeContent={deliveries && deliveries.shipmentStatusCount && deliveries.shipmentStatusCount.data && deliveries.shipmentStatusCount.data.label_generated} showZero={true} max={1000000000}>
                                        <LocalShippingOutlinedIcon />
                                    </Badge>
                                } 
                                iconPosition="end"
                            />
                            <Tab 
                                label="Manifest Closed"  
                                icon={
                                    <Badge badgeContent={deliveries && deliveries.shipmentStatusCount && deliveries.shipmentStatusCount.data && deliveries.shipmentStatusCount.data.manifest_closed} showZero={true} max={1000000000}>
                                        <LocalShippingOutlinedIcon />
                                    </Badge>
                                } 
                                iconPosition="end"
                            />
                            <Tab 
                                label="Picked Up"  
                                icon={
                                    <Badge badgeContent={deliveries && deliveries.shipmentStatusCount && deliveries.shipmentStatusCount.data && deliveries.shipmentStatusCount.data.picked_up} showZero={true} max={1000000000}>
                                        <LocalShippingOutlinedIcon />
                                    </Badge>
                                } 
                                iconPosition="end"
                            />
                            <Tab 
                                label="In Transit" 
                                icon={
                                    <Badge badgeContent={deliveries && deliveries.shipmentStatusCount && deliveries.shipmentStatusCount.data && deliveries.shipmentStatusCount.data.in_transit} showZero={true} max={1000000000}>
                                        <LocalShippingOutlinedIcon />
                                    </Badge>
                                } 
                                iconPosition="end"
                            />
                            <Tab 
                                label="Issues" 
                                icon={
                                    <Badge badgeContent={deliveries && deliveries.shipmentStatusCount && deliveries.shipmentStatusCount.data && deliveries.shipmentStatusCount.data.issues} showZero={true} max={1000000000}>
                                        <LocalShippingOutlinedIcon />
                                    </Badge>
                                } 
                                iconPosition="end"
                            />
                            <Tab 
                                label="Delivered" 
                                icon={
                                    <Badge badgeContent={deliveries && deliveries.shipmentStatusCount && deliveries.shipmentStatusCount.data && deliveries.shipmentStatusCount.data.delivered} showZero={true} max={1000000000}>
                                        <LocalShippingOutlinedIcon />
                                    </Badge>
                                } 
                                iconPosition="end"
                            />
                            <Tab 
                                label="Untracked" 
                                icon={
                                    <Badge badgeContent={deliveries && deliveries.shipmentStatusCount && deliveries.shipmentStatusCount.data && deliveries.shipmentStatusCount.data.untracked} showZero={true} max={1000000000}>
                                        <LocalShippingOutlinedIcon />
                                    </Badge>
                                } 
                                iconPosition="end"
                            />
                            <Tab 
                                label="Voided" 
                                icon={
                                    <Badge badgeContent={deliveries && deliveries.shipmentStatusCount && deliveries.shipmentStatusCount.data && deliveries.shipmentStatusCount.data.voided} showZero={true} max={1000000000}>
                                        <LocalShippingOutlinedIcon />
                                    </Badge>
                                } 
                                iconPosition="end"
                            />
                        </Tabs>
                    </Box>
                </Box>
                <Box 
                    sx={{ 
                        backgroundColor: '#FFFFFF', 
                        width: '100%',
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                        overflow: 'hidden'
                    }}
                >
                    {/* Direct layout rendering fixes potential header collision issues */}
                    <CustomToolbar />

                    <DataGrid
                        sx={{
                            border: 'none',
                            backgroundColor: '#FFFFFF',
                            overflow: 'hidden',
                            
                            '& .MuiDataGrid-topContainer': {
                                backgroundColor: '#F8FAFC',
                                '&::after': { display: 'none' }
                            },
                            
                            // Customizing Enterprise Header Styling
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#F8FAFC',
                                borderBottom: '1px solid #E2E8F0',
                                minHeight: '52px !important',
                                maxHeight: '52px !important'
                            },
                            '& .MuiDataGrid-columnHeader': {
                                color: '#475569',
                                fontWeight: 700,
                                fontSize: '13px',
                                textTransform: 'none',
                                letterSpacing: '0.1px',
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },
                            
                            // Customizing Rows and Cells Layout Bounds
                            '& .MuiDataGrid-row': {
                                transition: 'background-color 0.15s ease-in-out',
                                borderBottom: '1px solid #F1F5F9',
                                alignItems: 'center',
                                '&:hover': {
                                    backgroundColor: '#F8FAFC'
                                }
                            },
                            '& .MuiDataGrid-cell': {
                                fontSize: '13.5px',
                                color: '#334155',
                                borderBottom: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                py: '12px', 
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },

                            // Custom Linear Progress bar tracking layout styling overrides
                            '& .MuiLinearProgress-root': {
                                height: '3px',
                                backgroundColor: '#E2E8F0',
                                '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#1976d2'
                                }
                            }
                        }}
                        getRowId={(row) => row.id}
                        rows={deliveries && deliveries.deliveriesData && deliveries.deliveriesData.data}
                        columns={columns}
                        checkboxSelection={true}
                        rowSelectionModel={checkedIds}
                        onRowSelectionModelChange={(newSelectionModel) => {
                            setCheckedIds(newSelectionModel);
                            
                            // Map selected IDs back to full row objects
                            const selectedRowObjects = (deliveries?.deliveriesData?.data || []).filter(row => 
                                newSelectionModel.includes(row.id)
                            );
                            setCheckedItems(selectedRowObjects);
                        }}
                        autoHeight={true}
                        disableColumnFilter={true}
                        disableColumnMenu={true}
                        sortingMode="server"
                        onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                        sortModel={meta && meta.sorting && JSON.parse(meta.sorting)}
                        disableRowSelectionOnClick
                        slots={{
                            loadingOverlay: LinearProgress,
                            footer: CustomPagination,
                            NorowsData
                        }}
                        columnVisibilityModel={{
                            rate_total_charges: profile && profile.profile && profile.profile.hide_rate === true  ? false : true, 
                            rate_api_duty_charge: profile && profile.profile && profile.profile.hide_rate === true  ? false : true, 
                        }}
                        loading={
                            Boolean(deliveries?.deliveriesData?.loading) || 
                            Boolean(orders?.bulkLabel?.loading) || 
                            isPrintingLoading
                        }
                    />
                </Box>
            </div>
            <TrackingDrawer
                visible={trackingDrawerVisible} message={trackingMessage} isMultiPiece={isMultiPiece} onClose={onClose}
            />
            <OrderDrawer
                visible={orderDrawerVisible} onClose={orderOnClose}
            />
            <Popover
                open={Boolean(breakdownAnchorEl)}
                anchorEl={breakdownAnchorEl}
                onClose={handleDutiesClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: { p: 2, bgcolor: '#212b36', color: '#fff', borderRadius: '8px', minWidth: '180px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }
                }}
            >
                {isLoadingDuties ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
                        <CircularProgress size={20} sx={{ color: '#fff' }} />
                    </Box>
                ) : (
                    selectedBreakdown && (
                        selectedBreakdown.error || selectedBreakdown.message ? (
                            <Typography variant="caption" sx={{ fontSize: '11px', color: '#ffac81' }}>
                                {selectedBreakdown.error || selectedBreakdown.message}
                            </Typography>
                        ) : (
                            renderDutyTooltip(selectedBreakdown)
                        )
                    )
                )}
            </Popover>
        </>
    )
}

export default DeliveriesMysqlPage;
